import { useEffect, useState } from "react";
import styles from "../../../homepage/pages/Calculators.module.css";
import { analytics, logEvent } from "../../../../firebase.js";

import { BlockMath, InlineMath } from "react-katex";

import Select from "../components/Select";
import InputNumber from "../components/InputNumber";
import Output from "../components/Output";
import LongitudinalBar from "../components/LongitudinalBar.js";

import { concreteBending } from "../../utils/services/calculators";
import { Text, useToast } from "@chakra-ui/react";

function ConcreteBending({}) {
  const toast = useToast();
  // BENDING
  const [bendingInputs, setBendingInputs] = useState({
    fck: 20,
    fyk: 500,
    b: "",
    h: "",
    dl: "",
    msd: "",
  });
  const [bendingOutputs, setBendingOutputs] = useState({
    ln: "",
    domain: "",
    ast: "",
    asc: "",
    ast_min: "",
    memorial: {},
  });

  function updateBendingInputs(name, value) {
    if (value === "") {
      setBendingInputs((prevInputs) => ({
        ...prevInputs,
        [name]: value,
      }));
    } else {
      setBendingInputs((prevInputs) => ({
        ...prevInputs,
        [name]: parseFloat(value),
      }));
    }
    setBendingOutputs({
      ln: "",
      domain: "",
      ast: "",
      asc: "",
      ast_min: "",
    });
  }

  function onBendingCalculate() {
    if (
      bendingInputs["b"] === "" ||
      bendingInputs["h"] === "" ||
      bendingInputs["dl"] === "" ||
      bendingInputs["msd"] === ""
    ) {
      toast({
        title: "Preencha todos os campos",
        status: "warning",
        isClosable: true,
      });
    } else if (
      bendingInputs["b"] === 0 ||
      bendingInputs["h"] === 0 ||
      bendingInputs["dl"] === 0 ||
      bendingInputs["msd"] === 0
    ) {
      toast({
        title: "Os valores devem ser diferentes de 0",
        status: "warning",
        isClosable: true,
      });
    } else {
      concreteBending(bendingInputs).then((response) => {
        setBendingOutputs(response["data"]);
        logEvent(analytics, "button_click", {
          button_name: "concrete-bending-calculator-button",
        });
      });
    }
  }

  useEffect(() => {
    logEvent(analytics, "page_view", { page: "concrete-bending-calculator" });
  }, []);

  return (
    <div className={styles.section} key={"header"}>
      <h1 className={styles.calculatorName}>Flexão Simples Normal:</h1>
      <div className={styles.calculator}>
        <div className={styles.inputs}>
          <div className={styles.inputRow}>
            <h3 className={styles.rowTitle}>Dados de entrada:</h3>
          </div>
          <div className={styles.inputRow}>
            <Select
              text="Resultado"
              elements={["Área de aço"]}
              unit=""
              // elements={["Área de aço", "Momento resistente"]}
              // onChange={(e) => updateBendingInputs("fck", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <Select
              text="Seção"
              elements={["Retangular"]}
              unit=""
              // onChange={(e) => updateBendingInputs("fck", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <Select
              text="fck"
              elements={[
                20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90,
              ]}
              unit="MPa"
              onChange={(e) => updateBendingInputs("fck", e.target.value)}
            />
            <Select
              text="fyk"
              elements={[500]}
              unit="MPa"
              onChange={(e) => updateBendingInputs("fyk", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="b"
              unit="cm"
              onChange={(e) => updateBendingInputs("b", e.target.value)}
            />
            <InputNumber
              text="h"
              unit="cm"
              onChange={(e) => updateBendingInputs("h", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="dl"
              unit="cm"
              onChange={(e) => updateBendingInputs("dl", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="Msd"
              unit="tf.m"
              onChange={(e) => updateBendingInputs("msd", e.target.value)}
            />
          </div>
        </div>
        <div className={styles.buttons}>
          <button
            className={styles.calculateButton}
            onClick={onBendingCalculate}
          >
            CALCULAR
          </button>
        </div>
        <div className={styles.outputs}>
          <div className={styles.outputRow}>
            <h3 className={styles.rowTitle}>Resumo de resultados:</h3>
          </div>
          {bendingOutputs["ln"] === "" ? (
            <h4 className={styles.rowDescription}>
              {bendingOutputs["ln_text"]}
            </h4>
          ) : (
            <h4 className={styles.rowDescription}>
              {"O valor da LN é: " + bendingOutputs["ln"].toFixed(2) + " cm"}
            </h4>
          )}
          <Output text="Domínio" value={bendingOutputs["domain"]} />
          <Output text="As" value={bendingOutputs["ast"]} unit="cm²" />
          <Output text="As'" value={bendingOutputs["asc"]} unit="cm²" />
          <Output text="As,mín" value={bendingOutputs["ast_min"]} unit="cm²" />
          <LongitudinalBar />
        </div>
      </div>
      <div className={styles.memorial} key={"memorial"}>
        <h1>Memorial de Cálculo:</h1>
        {bendingOutputs["memorial"] &&
          Object.entries(bendingOutputs["memorial"]).map(
            ([className, subclasses]) => (
              <>
                <h2>{className}</h2>
                {Object.entries(subclasses).map(([subclassName, steps]) => (
                  <>
                    <h3>{subclassName}</h3>
                    {steps.map((step) => (
                      <>
                        <h4>{step["description"]}</h4>
                        <div className={styles.mathContainer}>
                          <BlockMath
                            math={step["formula"] + step["calculation"]}
                          />
                        </div>
                      </>
                    ))}
                  </>
                ))}
              </>
            )
          )}
      </div>
    </div>
  );
}

export default ConcreteBending;
